import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import EmbedAppBar from '../../../../Components/Layout/EmbedAppBar';
import { dynamoProductQueries } from '../../../../graphql/queries';
import { convertLangCodeToGraphqlEnum } from '../../../../helpers/locale.js';
import NotFoundMessage from '../../../../Components/Store/NotFoundMessage.js';
import Product from './Product.js';
import ProductSkeleton from '../../../../Components/Skeletons/ProductSkeleton';
import MainContainer from '../../../../Components/Layout/MainContainer.js';

const Wrapper = ({ children }) => (
  <div style={{ paddingTop: 50 }}>
    {children}
  </div>
);

const LinkedProduct = () => {
  const { language, linkId } = useParams();
  const navigate = useNavigate();

  const variables = {
    id: linkId,
    language: convertLangCodeToGraphqlEnum(language),
    currency: 'GBP' // this is hardcoded as the graphql query expects the locale but it doesn't use the currency part, just the language
  };

  const { data, loading, error } = useQuery(dynamoProductQueries.DynamoProductByLinkId, {
    variables
  });

  // An unknown link id either errors (the resolver throws) or resolves to a null
  // product — both mean "nothing to show", so fall back gracefully instead of surfacing
  // a Sentry error page or handing a null product to <Product>.
  const product = data && data.dynamoProductByLinkId;

  // Keep the page chrome stable and swap only the inner content: the product fetch shows
  // a skeleton in place (not a blank page), and there's no layout jump when it resolves.
  const renderContent = () => {
    if (loading) {
      return <ProductSkeleton />;
    }
    if (error || !product) {
      return (
        <NotFoundMessage
          message='product-not-found'
          actionLabel='browse-products'
          onAction={() => navigate('/products')}
        />
      );
    }
    return (
      <Product
        product={product}
        linkId={linkId}
      />
    );
  };

  return (
    <>
      <EmbedAppBar />
      <MainContainer>
        <Wrapper>
          {renderContent()}
        </Wrapper>
      </MainContainer>
    </>
  );
};

export default LinkedProduct;
